import React from 'react';

import './FeaturedEvent.sass';

import {FormattedMessage} from 'react-intl';
import {dhms} from '../../utils/timers';

import ProductPurchaseOccurrence from '../productPurchase/productPurchaseOccurrence/ProductPurchaseOccurrence';
import Button from '../button/Button';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import ChannelImage from '../../containers/channelUtils/ChannelImage';

import bgFallback from './assets/bg.png';
import { analyticsClearEcommerce, analyticsSelectCalendarItem } from '../../middlewares/analytics/actions';
import { connect } from 'react-redux';
import Pricing from "../pricing/Pricing";

@connect()
export default class FeaturedEvent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      eventParams: props.initialOccurrence || {},
      price: props.selectedVariant.price,
      countDown: '',
    };
  }

  updateCountdown = (selectedValue) => {
    const {days, hours, minutes, seconds} = dhms(
      Date.parse(selectedValue) - Date.now()
    );

    let shownCountdown = `${seconds}s`;

    if (minutes > 0) {
      shownCountdown = `${minutes}m ` + shownCountdown;
    }

    if (hours > 0) {
      shownCountdown = `${hours}h ` + shownCountdown;
    }

    if (days > 0) {
      shownCountdown = `${days}d ` + shownCountdown;
    }

    this.setState({
      countDown: shownCountdown,
    });
  };

  onOptionChange = (params) => {
    if (params.eventParams !== undefined) {
      this.setState(params);
      this.updateCountdown(params.eventParams.occurrence);
    } else {
      this.setState({
        eventParams: {},
        countDown: '-'
      });
    }
  };

  tick = () => {
    const {eventParams} = this.state;

    this.updateCountdown(eventParams.occurrence);
  };

  initTimer = () => {
    this.tick();
    this._timer = setInterval(this.tick, 1000);
  }

  clearTimer = () => {
    clearInterval(this._timer);
    this._timer = false;
  }

  componentDidMount() {
    this.initTimer();
  }

  componentDidUpdate(prevProps, prevState) {
    const {eventParams, countDown} = this.state;

    if (countDown === '-') {
      this.clearTimer();
      return false;
    }

    if (prevState.eventParams.occurrence !== eventParams.occurrence) {
      if (!this._timer) {
        this.initTimer();
        return false;
      }

      this.tick();
    }
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  onEventSelect = () => {
    const {dispatch, taxon, index, selectedVariant} = this.props;

    const product = {
      ...selectedVariant.product,
      price: selectedVariant.price,
    }

    dispatch(analyticsClearEcommerce());
    dispatch(analyticsSelectCalendarItem(taxon, product, index));
  }

  render() {
    const {variantId, occurrences, selectedVariant} = this.props;
    const {eventParams, countDown, price} = this.state;

    const {product} = selectedVariant;
    const {name} = product;

    let productLink;

    //task 335: removed &eventPreset=${eventParams.preset.id} don't need it anymore

    if (eventParams.id) {
      productLink = `/service/${
        selectedVariant.product.slug
      }?variant=${encodeURIComponent(selectedVariant.code)}&eventId=${eventParams.id}&occurrence=${encodeURIComponent(
        eventParams.occurrence
      )}`;
    } else {
      productLink = `/service/${
        selectedVariant.product.slug
      }?variant=${encodeURIComponent(selectedVariant.code)}`;
    }

    const image =
      (Array.isArray(product.images) &&
        product.images.length &&
        product.images.find((image) => image.type === 'base')) ||
      product.images.find((image) => image.type === 'main');

    return (
      <div className="featured-event">
        <ChannelLink to={productLink} className="featured-event__top" onClick={this.onEventSelect}>
          <div className="featured-event__image">
            {image ? (
              <ChannelImage src={image} width={540} height={340} alt={name} />
            ) : (
              <img src={bgFallback} alt={name} />
            )}
          </div>
          <div className="featured-event__top-content">
            <div className="featured-event__title">{name}</div>
            {selectedVariant.name && <div className="featured-event__subtitle">{selectedVariant.name}</div>}
          </div>
        </ChannelLink>

        <div className="featured-event__control">
          <div className="featured-event__options">
            <ProductPurchaseOccurrence
              smallSelect
              optionGroupId={variantId}
              occurrences={occurrences}
              eventParams={eventParams}
              selectedVariant={selectedVariant}
              onChange={(eventParams) => this.onOptionChange({eventParams})}
              preferFirstOccurrence
            />
            <div className="featured-event__wrapper">
              <p className="featured-event__starts"><FormattedMessage id="section.event.price-starts" /></p>
              <p className="featured-event__price"><Pricing value={price} originalValue={product.originalPrice}/></p>
            </div>
          </div>

          <div className="featured-event__action">
            <div className="featured-event__countdown">
              <div className="featured-event__countdown-title">
                <FormattedMessage id="section.event.countdown-starts" />:
              </div>
              <div className="featured-event__countdown-time">{countDown}</div>
            </div>

            <div className="featured-event__button">
              <Button
                component={ChannelLink}
                filled
                small
                full
                to={productLink}
                onClick={this.onEventSelect}
              >
                <FormattedMessage id="section.event.action" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/featuredEvents/FeaturedEvent.js